import React from 'react'

const Github = (props) => (
  <svg 
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 -2 16 15.289"
    preserveAspectRatio="xMidYMid meet"
  >
    <path stroke={props.color} fill="transparent" d="M11.683,0c0.207,0.471,0.343,1.256,0.142,1.831c0.822,0.702,1.105,2.407,0.707,3.804
    C13.703,5.724,15.1,5.592,16,5.95c-0.842-0.107-1.992-0.32-3.079-0.247c-0.206,0.015-0.511-0.008-0.496,0.282
    c1.258,0.1,2.508,0.206,3.54,0.529c-1.023-0.167-2.268-0.422-3.54-0.459C11.9,7.093,10.842,7.604,9.381,7.711
    C9.539,8.053,9.84,8.183,9.912,8.733c0.109,0.821-0.17,2.022,0.106,2.569c0.132,0.262,0.349,0.27,0.496,0.493
    c-0.358,0.424-1.245-0.048-1.347-0.493c-0.173-0.764,0.265-1.947-0.212-2.466C8.99,9.671,8.76,10.84,8.992,11.585
    c0.092,0.292,0.355,0.403,0.283,0.669c-1.663,0.169-0.968-2.152-1.24-3.521C7.785,8.75,7.895,9.108,7.894,9.26
    c-0.006,1.338,0.274,3.173-1.167,2.994C6.683,11.973,6.92,11.877,7.01,11.62c0.263-0.752-0.05-1.875,0.071-2.783
    c-0.551,0.416,0.057,1.865-0.283,2.606c-0.196,0.427-0.83,0.613-1.311,0.424c0.062-0.319,0.392-0.268,0.531-0.564
    c0.194-0.413,0.001-1.01,0.071-1.62C5.07,9.886,4.281,9.654,3.894,9.015C3.721,8.727,3.678,8.388,3.469,8.133
    C3.262,7.879,2.93,7.846,2.832,7.5c1.262-0.303,1.309,1.298,2.443,1.337c0.348,0.014,0.527-0.1,0.85-0.175
    c0.09-0.404,0.282-0.705,0.566-0.917c-1.41-0.19-2.574-0.632-3.116-1.689C2.293,6.119,1.121,6.291,0.035,6.55
    C1.021,6.191,2.237,6.062,3.54,6.021C3.463,5.559,2.79,5.686,2.373,5.703C1.596,5.738,0.617,5.835,0,5.95
    c0.896-0.319,2.15-0.278,3.363-0.282C2.992,4.506,3.12,2.66,3.93,1.971C3.7,1.394,3.771,0.45,4.072,0
    C4.975,0.039,5.521,0.433,6.09,0.811c0.703-0.2,1.442-0.301,2.405-0.248c0.407,0.022,0.827,0.205,1.134,0.176
    c0.299-0.028,0.629-0.363,0.92-0.493C10.928,0.078,11.248,0.015,11.683,0z"/>
  </svg>
)

export default Github


// WEBPACK FOOTER //
// ./src/components/Icons/Github.js